import { useState, useEffect } from 'react'
import { getAllPosts } from '../utils/blogUtils'

export const useBlogPosts = (category) => {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true)
        setError(null)
        const rawPosts = await getAllPosts()
        const sorted = [...rawPosts].sort((a, b) => new Date(b.date) - new Date(a.date))
        const filtered = category
          ? sorted.filter((p) => p.category === category)
          : sorted
        setPosts(filtered)
      } catch (err) {
        console.error('Failed to load blog posts:', err)
        setError(err.message || 'Failed to load blog posts')
      } finally {
        setLoading(false)
      }
    }

    fetchPosts()
  }, [category])

  const refetch = async () => {
    try {
      setLoading(true)
      setError(null)
      const rawPosts = await getAllPosts()
      const sorted = [...rawPosts].sort((a, b) => new Date(b.date) - new Date(a.date))
      const filtered = category
        ? sorted.filter((p) => p.category === category)
        : sorted
      setPosts(filtered)
    } catch (err) {
      console.error('Failed to load blog posts:', err)
      setError(err.message || 'Failed to load blog posts')
    } finally {
      setLoading(false)
    }
  }

  return { posts, loading, error, refetch }
}
